<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-if="starred" color="yellow darken-1" v-bind="attrs" v-on="on" class="pointer" @click="starrProfile">
        mdi-star
      </v-icon>
      <v-icon v-else color="" v-bind="attrs" v-on="on" class="pointer" @click="starrProfile">mdi-star-outline</v-icon>
    </template>
    <span v-if="starred">Starred</span>
    <span v-else>Not starred</span>
  </v-tooltip>
</template>

<script>
  import api from '@/api/index';
  import Vue from "vue";

  export default {
    props: ['id', 'starred'],
    name: "starredProfile",
    mounted() {

    },
    methods: {
      starrProfile() {
        let id = this.id;
        let starred = !this.starred;
        api.members.starred({_id: id, starred: starred})
          .then(response => {
            let yesNo = starred ? '' : 'not'
            Vue.notify({
              group: 'actions',
              type: starred ? 'success' : 'info',
              text: `Member ${yesNo} starred`
            });
            this.$emit('profile-starred', {id, starred})
          }).catch(error => {
          Vue.notify({
            group: 'actions',
            type: 'error',
            text: 'Member could not be starred'
          });
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Buttons/Profiles/starredProfile.vue